import React from 'react'

import '../../assets/css/portal.css';
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/app.min.css';

const Spinner = (props) => {
    const { size, center, message } = props;

    return (
        <>
            {size ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : (
                <div className="screen-loader d-flex justify-content-center  flex-column align-items-center">
                    <div className="spinner-border" role="status" aria-hidden="true">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    {message && <p style={{ marginTop: "10px" }}>{message}</p>}
                </div>
            )}
        </>
    )
}

export default Spinner